import React from 'react';

import MoveToCoreCurriculumButton from '../MoveToCoreCurriculumButton';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

function MiscellaneousMenteeModulesTableRow({ menteeModule }) {
  const { academy_module: academyModule, order } = menteeModule;
  const { name } = academyModule;

  return (
    <TableRow>
      <TableCell>{order}</TableCell>
      <TableCell>{name}</TableCell>
      <TableCell>
        <MoveToCoreCurriculumButton menteeModule={menteeModule} />
      </TableCell>
    </TableRow>
  );
}

export default MiscellaneousMenteeModulesTableRow;
